import type { GridColDef } from "@mui/x-data-grid-premium";
import type { TreeItemTemplatePlaceholderFragment } from "../../doc-items/Fragments.generated.js";
import { DataGridTemplatePlaceholderCell } from "../cells/DataGridTemplatePlaceholderCell.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

interface Options {
  headerName: string;
  canEdit: boolean;
  projectId: string;
  docId: string;
  refetchWizardQuestions: () => Promise<unknown>;
  onCompleted?: (itemId: string) => void;
}

export function createTemplatePlaceholderColumn<
  T extends DocDataGrid_ItemFragment & TreeItemTemplatePlaceholderFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "templatePlaceholder",
    headerName: options.headerName,
    width: 40,
    resizable: false,
    sortable: false,
    filterable: false,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      return (
        <DataGridTemplatePlaceholderCell
          projectId={options.projectId}
          docId={options.docId}
          item={params.row.item}
          disabled={!options.canEdit}
          refetchWizardQuestions={options.refetchWizardQuestions}
          onCompleted={options.onCompleted}
        />
      );
    },
  };
}
